module.exports = __webpack_public_path__ + "static/media/task9Planet1.a50f9e29.png";